// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.client-table
{
    /* border: 1px solid rgb(216 221 233); */
    border-radius: 5px;
}

.client-table-head{
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    /* grid-row-gap: 10px;
    grid-column-gap:10px ; */
    position: -webkit-sticky;
    position: sticky;
}

.client-table-head>div>div{
 display: flex;
 align-items: center;
}

.client-table-head>div>div>div{
    margin-left: 10px ;
   }

.client-table-head>div{
    position: relative;
    font-size: 15px;
    font-weight: 900;
    padding: 1.25rem 0.5rem 0.75rem;
    text-align: center;
    justify-content: space-between;
    /* background: #212130 ; */
    left: 0;
    position: -webkit-sticky;
    position: sticky;
    z-index: 11;
    align-items: center;
    /* border-right: 1px solid rgb(216 221 233); */
    /* border-radius: 3px; */
    color:#6c757d;
    display: flex;
    flex-direction: row;
    /* background-color: rgb(229 231 235); */
    margin-bottom: 0.25rem;
    /* padding: 0.5rem; */
}


.input-search{
    border: 1px solid;
    border-color: rgb(229 231 235/1);
    border-radius: 5px;
    padding-left: 5px;
    height: 30px;
}

.client-table-body>div>div{  
    font-weight: 300;
    padding: 1.25rem 0.5rem 0.75rem;
    text-align: end;
    justify-content: center;
    left: 0;
    /* position: sticky;
    z-index: 11; */
    align-items: center;
    border-radius: 3px;
    color: #6c757d;
    display: flex;
    flex-direction: row;
    margin-bottom: 0.25rem;
    font-family: 12px Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif !important;
}



.client-table-body>div{
    
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
}

.client-table-body{
    overflow-y: scroll;
    height: 400px;
}

.client-table{
   width: 90%;
   
}`, "",{"version":3,"sources":["webpack://./src/components/ClientsTable.css"],"names":[],"mappings":";AACA;;IAEI,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD;4BACwB;IACxB,wBAAgB;IAAhB,gBAAgB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;IACI,kBAAkB;GACnB;;AAEH;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;IAClB,8BAA8B;IAC9B,0BAA0B;IAC1B,OAAO;IACP,wBAAgB;IAAhB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,8CAA8C;IAC9C,wBAAwB;IACxB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,sBAAsB;IACtB,qBAAqB;AACzB;;;AAGA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;IACf,uBAAuB;IACvB,OAAO;IACP;kBACc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,sFAAsF;AAC1F;;;;AAIA;;IAEI,aAAa;IACb,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;GACG,UAAU;;AAEb","sourcesContent":["\n.client-table\n{\n    /* border: 1px solid rgb(216 221 233); */\n    border-radius: 5px;\n}\n\n.client-table-head{\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    /* grid-row-gap: 10px;\n    grid-column-gap:10px ; */\n    position: sticky;\n}\n\n.client-table-head>div>div{\n display: flex;\n align-items: center;\n}\n\n.client-table-head>div>div>div{\n    margin-left: 10px ;\n   }\n\n.client-table-head>div{\n    position: relative;\n    font-size: 15px;\n    font-weight: 900;\n    padding: 1.25rem 0.5rem 0.75rem;\n    text-align: center;\n    justify-content: space-between;\n    /* background: #212130 ; */\n    left: 0;\n    position: sticky;\n    z-index: 11;\n    align-items: center;\n    /* border-right: 1px solid rgb(216 221 233); */\n    /* border-radius: 3px; */\n    color:#6c757d;\n    display: flex;\n    flex-direction: row;\n    /* background-color: rgb(229 231 235); */\n    margin-bottom: 0.25rem;\n    /* padding: 0.5rem; */\n}\n\n\n.input-search{\n    border: 1px solid;\n    border-color: rgb(229 231 235/1);\n    border-radius: 5px;\n    padding-left: 5px;\n    height: 30px;\n}\n\n.client-table-body>div>div{  \n    font-weight: 300;\n    padding: 1.25rem 0.5rem 0.75rem;\n    text-align: end;\n    justify-content: center;\n    left: 0;\n    /* position: sticky;\n    z-index: 11; */\n    align-items: center;\n    border-radius: 3px;\n    color: #6c757d;\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 0.25rem;\n    font-family: 12px Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif !important;\n}\n\n\n\n.client-table-body>div{\n    \n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.client-table-body{\n    overflow-y: scroll;\n    height: 400px;\n}\n\n.client-table{\n   width: 90%;\n   \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
